<template>
  <div class="expertiseBoxes" v-if="expertises && expertises.length">
    <div class="wrapper">
      <h5>{{ data.title }}</h5>
      <h4 v-html="nl2br(data.subline)"></h4>
      <div class="expertiseBoxes__container">
        <div class="expertiseBoxes__box" v-for="(expertise, key) in expertises " :key="key">
          <a href="" @click.prevent="select(expertise, key)">
            <div class="expertiseBoxesMountainSnapshot">
              <img v-if="key === 0" src="./../../assets/images/mountain-1.png" alt="Nunatak Mountains" />
              <img v-if="key === 1" src="./../../assets/images/mountain-2.png" alt="Nunatak Mountains" />
              <img v-if="key === 2" src="./../../assets/images/mountain-3.png" alt="Nunatak Mountains" />
              <img v-if="key === 3" src="./../../assets/images/mountain-4.png" alt="Nunatak Mountains" />
            </div>
            <span class="number">{{ '0' + (key+1) }}</span>
            <span class="type">{{ expertise.acf.type }}</span>
            <span class="title" v-html="expertise.title.rendered"></span>
            <span class="label">
              <span class="link-text">{{ $root.translate('more') }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 182.7 176.4"><path fill="#4b4b4d" d="M95 1.1L84 11.9l67.1 68.4H1v15.4h151.6l-67.3 68.6 11 10.8L181 88.8z"/></svg>
            </span>
          </a>
        </div>
      </div>
    </div>
    <expertise-layer v-if="selectedExpertise" @close="deselect" @next="next" @prev="prev" :expertise="selectedExpertise" :data="data"></expertise-layer>
  </div>
</template>

<script>
import ExpertiseLayer from './ExpertiseLayer';
import { mapState } from 'vuex';
export default {
  name: 'ExpertiseBoxes',
  props: ['data'],
  data() {
    return {
      selectedExpertise: null,
    }
  },
  components: {
    ExpertiseLayer
  },
  computed: mapState({
    expertises: state => state.expertise.all,
    language: state => state.language.language
  }),
  watch: {
    language() {
      this.$store.dispatch('expertise/getAll', { language: this.language });
    }
  },
  mounted() {
    this.$store.dispatch('expertise/getAll', { language: this.language });
  },
  methods: {
    nl2br (str, is_xhtml) {
      if (typeof str === 'undefined' || str === null) {
          return '';
      }
      const breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    },
    select(expertise, index) {
      expertise.index = index;
      this.selectedExpertise = expertise;
    },
    deselect() {
      setTimeout(() => this.selectedExpertise = null, 1000);
    },
    next() {
      let nextExpertise = this.expertises[0];
      nextExpertise.index = 0;
      this.expertises.forEach((expertise, index) => {
        if(index === this.selectedExpertise.index+1) {
          nextExpertise = expertise;
          nextExpertise.index = index;
        }
      });
      
      this.selectedExpertise = nextExpertise;
    },
    prev() {
      let prevExpertise = this.expertises[this.expertises.length-1];
      prevExpertise.index = this.expertises.length -1;
      this.expertises.forEach((expertise, index) => {
        if(index === this.selectedExpertise.index-1) {
          prevExpertise = expertise;
          prevExpertise.index = index;
        }
      });
      this.selectedExpertise = prevExpertise;
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/config';
.expertiseBoxes {
  margin-bottom: 130px;
  h4 {
    font-size: 38px;
    line-height: 47px;
    font-weight: 300;
    margin: 0 0 1em;
    @media screen and (max-width: $medium) { 
      font-size: 30px;
      line-height: 38px;
    }
    @media screen and (max-width: $small) {
      font-size: 25px;
      line-height: 30px;
    }
  }
}

.expertiseBoxes__container {
  display: flex;
  flex-wrap: wrap;
  @media screen and (max-width: $small) {
    display: block;
  }
  
  .expertiseBoxes__box {
    width: 50%;
    padding: 0 20px 20px 0;
    box-sizing: border-box;
    position: relative;
    @media screen and (max-width: $small) {
      width: 100%;
      padding: 0 0 20px 0;
    }
    
    &:after {
      content: '';
      display: block;
      padding-top: 60%;
      @media screen and (max-width: $small) {
        display: none;
      }
    }
    &:nth-child(4n),
    &:nth-child(3n) {
      transform: translate(33.333%);
      @media screen and (max-width: $medium) {
        transform: none;
      }
    }
    a {
      position: absolute;
      top: 0;
      bottom: 20px;
      right: 20px;
      left: 0;
      color: white;
      text-decoration: none;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      background: $primary;
      padding: 30px;
      transition: background-color 500ms ease 100ms;
      @media screen and (max-width: $small) {
        position: relative;
        overflow: hidden;
      }
      .expertiseBoxesMountainSnapshot {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 0;
        opacity: 0;
        transition: opacity 500ms ease 100ms;
        background: $color;
        overflow: hidden;
        img,
        canvas {
          position: absolute;
          width: 200%;
          left: 50%;
          bottom: 50%;
          transform: translate(-50%, 50%);  
        }
      }
      
      span {
        display: block;
        position: relative;
        z-index: 10;
        &.number {
          font-size: 17px;
          margin: 0 0 1em;
          font-weight: 300;
          letter-spacing: 0.135em;
          transition: transform 500ms ease;
          @media screen and (max-width: $small) {
            font-size: 8px;
          }
        }
        &.type,
        &.title {
          font-size: 38px;
          line-height: 47px;
          max-width: 50%;
          transition: transform 500ms ease 100ms, color 500ms ease;
          @media screen and (max-width: $medium) { 
            font-size: 28px;
            line-height: 36px;
          }
          @media screen and (max-width: $small) {
            font-size: 25px;
            line-height: 30px;
          }
        }
        &.title {
          margin: 0 0 20px;
          transition: transform 500ms ease 200ms, color 500ms ease;
        }
        &.label {
          display: flex;
          .link-text {
            max-width: 0;
            overflow: hidden;
            transition: max-width 500ms ease;
            word-wrap: none;
            white-space: nowrap;
          }
        }
      }
      svg {
        width: 16px;
        height: 16px;
        transform: rotate(-45deg);
        transition: transform 300ms ease;
        transform-origin: center center;
        > * {
          fill: white;
        }
      }

      &:hover {
        background: $color;
        .expertiseBoxesMountainSnapshot {
          opacity: 1;
        }
        span {
          &.number,
          &.type,
          &.title {
            transform: translate(0,-40px);
            color: white;
            @media screen and (max-width: $small) {
              transform: translate(0,0);
            }
          }
          &.title {
            color: $primary;
          }
          &.label {
            .link-text {
              width: auto;
              max-width: 120px;
            }
          }
        }
        svg {
          transform: rotate(0deg) translate(20px, 2px);
        }
      }
    }
    
    span.title {
      color: $color;
    }
  }
}
</style>